// extracted by mini-css-extract-plugin
export default {"container":"DataProcessors_container__NXGBz","title":"DataProcessors_title__TrytR","tableWrapper":"DataProcessors_tableWrapper__7AfrM","table":"DataProcessors_table__FwlkH"};